export default __webpack_public_path__ + "static/media/042.4a1e1efe.jpg";